import React from 'react';
import './Experience.css';

const Experience = () => {
  const experienceData = [
    {
      year: '2024 - Present',
      position: 'IT Student',
      company: 'GEN-I',
      description: 'Provided technical support for employees and daily IT operations. Worked with PowerShell, Active Directory, Azure AD and Splunk. Assisted the cyber security and infrastructure teams. Helped automate tasks using simple PowerShell scripts.'
    },
    {
      year: '2023 - 2024',
      position: 'IT Student',
      company: 'HEALTH CENTER LJUBLJANA',
      description: 'Created and programmed phone voice prompts for clinics using HTML, Microsoft Text-to-Speech and Audacity. Worked with healthcare systems such as IRIS and LABIS. Assisted with everyday IT tasks.'
    }
  ];

  return (
    <section className="experience" id="experience">
      <div className="experience-container">
        <div className="section-header">
          <h2 className="section-title pink-bg">EXPERIENCE</h2>
        </div>

        <div className="experience-timeline">
          {experienceData.map((item, index) => (
            <div key={index} className="experience-item">
              <div className="experience-year">{item.year}</div>
              <div className="experience-content">
                <h3 className="experience-position">{item.position}</h3>
                <h4 className="experience-company">{item.company}</h4>
                <p className="experience-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="cv-download-section">
          <a href="/KRISTIJANA-CV.pdf" download className="cv-download-btn">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            Download My CV
          </a>
        </div>
      </div>
    </section>
  );
};

export default Experience;